// extracted by mini-css-extract-plugin
module.exports = {"bookings-container":"bookings_bookings-container__BzwoZ"};